module.exports = __webpack_public_path__ + "static/media/arrow-back.872751ab.svg";